import React from 'react';

const Card = (props) => {
    return (
        <div  style={{ height: 270, paddingRight:30, float: 'left'}}>
            <div className="card">
                <div className="card-image" style={{ width: 240}}>
                       <span className="card-title">{props.payload.fields.header.stringValue}</span>
                </div>
                <div className="card-content">
                    {props.payload.fields.descrition.stringValue}
                    <p> <a  href="/">{props.payload.fields.price.stringValue}</a></p>
                </div>
                <div className="card-action">
                 </div>
            </div>
        </div>
    );
};

export default Card;